var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row custom_phone_country_select" }, [
    _c("div", { staticClass: "col-md-6" }, [
      !_vm.editClient
        ? _c(
            "div",
            [
              _c("p", [_vm._v(_vm._s(_vm.client.name))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.client.email))]),
              _vm._v(" "),
              _vm._l(_vm.client.phones, function (phone) {
                return _c("div", [
                  _c("p", [_vm._v(_vm._s(phone.phone))]),
                  _vm._v(" "),
                  phone.comment
                    ? _c("p", [_vm._v(_vm._s(phone.comment))])
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editClient
        ? _c("div", [
            _c("div", { staticClass: "mb-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.client.name,
                    expression: "client.name",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  disabled: !_vm.allowToChangeClientData,
                  placeholder: "ФИО клиента",
                },
                domProps: { value: _vm.client.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.client, "name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.client.comment,
                    expression: "client.comment",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  disabled: !_vm.allowToChangeClientData,
                  placeholder: "комментарий к клиенту",
                },
                domProps: { value: _vm.client.comment },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.client, "comment", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.client.email,
                    expression: "client.email",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  disabled: !_vm.allowToChangeClientData,
                  placeholder: "email",
                },
                domProps: { value: _vm.client.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.client, "email", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.$editNewOrder.phone_call_id
              ? _c("div", { staticClass: "alert alert-info p-2 mb-2 mt-1" }, [
                  _c("p", [
                    _c("i", { staticClass: "icon-fa icon-fa-info-circle" }),
                    _vm._v(" Текущий телефонный звонок "),
                    _vm.$editNewOrder.phone
                      ? _c("strong", [_vm._v(_vm._s(_vm.$editNewOrder.phone))])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("привязан к текущей заявке")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "phones" },
              [
                _vm._l(_vm.phones, function (phone, index) {
                  return _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("VuePhoneNumberInput", {
                            staticClass: "phone_input",
                            attrs: {
                              loader: _vm.phoneSearch[index],
                              translations: {
                                countrySelectorLabel: "Код страны",
                                countrySelectorError: "Верный телефон",
                                phoneNumberLabel: "Номер телефона",
                                example: "Пример :",
                              },
                              "only-countries": [
                                "RU",
                                "BY",
                                "UA",
                                "KG",
                                "KZ",
                                "AM",
                              ],
                              "default-country-code": phone.country || "RU",
                            },
                            on: { update: (e) => _vm.phoneValidate(e, index) },
                            model: {
                              value: phone.phone,
                              callback: function ($$v) {
                                _vm.$set(phone, "phone", $$v)
                              },
                              expression: "phone.phone",
                            },
                          }),
                          _vm._v(" "),
                          phone && phone.valid && phone.phone
                            ? _c("BlackListButton", {
                                attrs: {
                                  phone: phone,
                                  blackList: _vm.blackList[index],
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          phone.valid
                            ? _c("MakeCall", {
                                attrs: {
                                  phone: phone,
                                  order: _vm.$editNewOrder,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: phone.comment,
                              expression: "phone.comment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Комментарий к телефону",
                          },
                          domProps: { value: phone.comment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(phone, "comment", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        index > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-danger no-wrap",
                                on: {
                                  click: function ($event) {
                                    return _vm.removePhone(index)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-trash-o",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("PhoneCallsHistory", {
                        attrs: { phone: phone, orderId: _vm.$editNewOrder.id },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-info",
                      on: { click: _vm.addNewPhoneLine },
                    },
                    [_vm._v("добавить телефон")]
                  ),
                ]),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _vm.question
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _vm.question.type === "phoneOccupied" ||
            _vm.question.type === "nameDiff"
              ? _c("div", [
                  _c("h6", [
                    _vm._v("Телефон "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.mixinPrintPhone(_vm.question.client.full_phone)
                        )
                      ),
                    ]),
                    _vm._v(" принадлежит клиенту:"),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.question.client.client.name))]),
                  _vm._v(" "),
                  _c("div", [
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-warning",
                        on: {
                          click: function ($event) {
                            return _vm.updateQuestion("rejectClient")
                          },
                        },
                      },
                      [
                        _vm._v("Отвязать телефон от клиента "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.question.client.client.name)),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        on: {
                          click: function ($event) {
                            return _vm.updateQuestion("acceptClient")
                          },
                        },
                      },
                      [
                        _vm._v("Использовать клиента\n            "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.question.client.client.name)),
                        ]),
                        _vm._v(" в заявке\n          "),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.addressCases && _vm.addressCases.length
        ? _c("div", [
            _c("p", { staticClass: "mb-0" }, [
              _c("i", { staticClass: "icon-blue icon-fa icon-fa-motorcycle" }),
              _vm._v(" Использовались адреса ("),
              _c("strong", [_vm._v(_vm._s(_vm.addressCases.length))]),
              _vm._v("):"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  address_list: true,
                  short_address_list:
                    !_vm.showAllAddresses || _vm.addressCases.length > 4,
                },
              },
              _vm._l(_vm.addressCases, function (a) {
                return _c("p", [_vm._v(_vm._s(a))])
              }),
              0
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "m-0 mb-1" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("i", {
            staticClass: "icon-blue icon-fa icon-fa-calendar-check-o",
          }),
          _vm._v(" История заявок\n      "),
          _vm._l(Object.keys(_vm.historyOrders), function (phone) {
            return _c("div", [
              _c("p", { staticClass: "mb-1" }, [
                _vm._v("телефон: "),
                _c("strong", [_vm._v(_vm._s(phone))]),
                _vm._v(" всего заявок ("),
                _c("strong", [
                  _vm._v(_vm._s(_vm.historyOrders[phone].orders.length)),
                ]),
                _vm._v(")\n          "),
                _vm.historyOrders[phone].orders.length > 3
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showOrders(phone)
                          },
                        },
                      },
                      [_vm._v("показать\n            все")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "history_orders" }, [
                _c(
                  "table",
                  { staticClass: "table table-sm table-striped mt-0" },
                  [
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.historyOrders[phone].orders,
                          function (o, index) {
                            return index < 3 || _vm.historyOrders[phone].open
                              ? [
                                  _c("tr", [
                                    _c("td", [
                                      _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          _vm._s(o.project_label) +
                                            "\n                    "
                                        ),
                                        o.report_date || o.created_at
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.printDate(
                                                      o.report_date ||
                                                        o.created_at,
                                                      "DD.MM.YYYY"
                                                    )
                                                  ) +
                                                  ")"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "badge badge-warning": o.status < 0,
                                            "badge badge-info":
                                              o.status == 1 ||
                                              o.status == 2 ||
                                              o.status === 8,
                                            "badge badge-dark": o.status > 100,
                                            "badge badge-success":
                                              o.status == 3,
                                            "badge badge-dark":
                                              o.status == 0 || o.status == 9999,
                                          },
                                        },
                                        [
                                          _vm._v(_vm._s(o.id)),
                                          _c("br"),
                                          _vm._v(_vm._s(o.status_label)),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(o.reject_comment)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        { staticClass: "drugs_list" },
                                        [
                                          _c("p", [
                                            _vm._v("Клиент: "),
                                            _c("strong", [
                                              _vm._v(_vm._s(o.client_name)),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(o.details, function (detail) {
                                            return _c("p", [
                                              _vm._v(
                                                _vm._s(detail.new_drug.title)
                                              ),
                                            ])
                                          }),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "drugs_list" }, [
                                      _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(_vm._s(o.formated_report_date)),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "mb-0" }, [
                                        _c("strong", [
                                          _vm._v(_vm._s(o.price) + " "),
                                          o.delivery_price
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(o.delivery_price) +
                                                    ")"
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                        _vm._v("\n                    руб"),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              : _vm._e()
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }